import {User} from './user.class';

export class CheckpointComment {
    id: number;
    checkpoint_id: number;
    user_id: number;
    postpone_hours: number;
    comment: string;

    created_at: Date;
    updated_at: Date;
    deleted_at?: Date;

    user?: User;
}
